export default "__VITE_ASSET__C$FXFupO__"